const stats = state => state.stats || {};

export const getStatsSummary = state => stats(state).summary;
export const isStatsLoading = state => stats(state).loading === true;

// Current count of published (active) forms, or null until the summary loads.
// Range-independent — active_forms is never filtered by the date range.
export const getActiveFormsCount = state => {
  const s = stats(state).summary;
  return s && typeof s.active_forms === 'number' ? s.active_forms : null;
};
